import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import LTRCommonActionPanel from '../../shared/domains/LTRCommonActionPanel'

import QuickAddAssets from './QuickAddAssets';

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';

import {AssetType} from '../../../Enums';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  }
}));

const AssetsActionPanel = (props) => {
  const classes = useStyles();

  const [assetType, setAssetType] = useState('');
  const [quickAddOpen, setQuickAddOpen] = useState(false);

  const handleAddAsset = (type) => {
    setAssetType(type);
    setQuickAddOpen(true);
  }

  const handleCloseQuickAddOpen = () => {
    setQuickAddOpen(false);
  }

  const handleSave  = (account) => {
    props.handleAddNotification(account);
  }

  const handleReceiveData = (data) => {
    if (props.handleReceiveData) {
      props.handleReceiveData(data);
    }
  }

  return (
    <div className={classes.root}>
      <LTRCommonActionPanel
        actionComponents = {
          <ButtonGroup
            orientation="vertical"
            size = "small"
            color="primary"
            variant="text"
            aria-label="vertical outlined primary button group"
            >    
            <Button className={classes.button} onClick={() => handleAddAsset(AssetType.Vehicle)}  color="primary">
              Add a vehicle
            </Button>
            <Button className={classes.button} onClick={() => handleAddAsset(AssetType.Housing)} color="primary">
              Add a house (primary or vacation)
            </Button>
            <Button className={classes.button} onClick={() => handleAddAsset(AssetType.Building)} color="primary">
              Add rental property
            </Button>
            <Button className={classes.button} onClick={() => handleAddAsset(AssetType.Pension)} color="primary">
              Add a pension
            </Button>
            <Button className={classes.button} onClick={() => handleAddAsset(AssetType.Annuity)} color="primary">
              Add an annuity
            </Button>
            <Button className={classes.button} onClick={() => handleAddAsset(AssetType.Digital)} color="primary">
              Add a digital asset
            </Button>
            <Button className={classes.button} onClick={() => handleAddAsset(AssetType.Cash)} color="primary">
              Add cash
            </Button>
            <Button className={classes.button} onClick={() => handleAddAsset(AssetType.Other)} color="primary">
              Add other asset
            </Button>
          </ButtonGroup>
        }
        />
        {quickAddOpen ? (
           <QuickAddAssets 
              open = {quickAddOpen}
              assetType = {assetType}
              handleClose = {handleCloseQuickAddOpen}
              handleSave = {handleSave}
              handleReceiveData = {handleReceiveData}
           />) 
          : null
        }  
    </div>
  )
}

AssetsActionPanel.propTypes = {
  handleAddNotification: PropTypes.func.isRequired,
  handleReceiveData: PropTypes.func.isRequired
}

export default (AssetsActionPanel)
